import {
  createContext,
  useState, useMemo
} from "react";

//This defines the data structure for our Authorization data. Basically we will maintain a list of roles
//and the assets on the application that they can access
export type UserAuthData = {
  role: string;
  assets: string[];
};

//We wil pass this function handle to child components as a context. That way, child component can invoke this
export type Authorize = {
  setCurrentUserRole: (role: string) => void;
  setTesterId: (testerId: number) => void;
  isAuthorized: (asset: string) => boolean;
  currentUserRole: string,
  testerId:number;
};

//export const UserAuthContext = createContext<UserContextInterface>(defaultContextState);
//Create the context using to pass the Authorize object via the context
export const UserAuthContext = createContext<Authorize | null>(null);

//Create a type to create  component which we can pass on to the child components
type UserProviderProps = {
  readonly children: React.ReactNode;
  readonly esecUserRole: string;
  readonly esecTesterId: number;
};

export default function UserAuthDataProvider({ children, esecUserRole, esecTesterId }: UserProviderProps) {
  //Set the intial state with all the authorization data
  let userAuthData = [
    {
      role: "PD-AVIRP-SuperUser",
      assets: [
        "AV_LandingPage",
        "AV_Tester_View",
        "AV_Add_Tester,AV_Edit_Tester,AV_Delete_Tester,AV_View_Incidents,AV_Veh_Document_Add",
        "AV_Home_MenuLink"
      ],
    },
    {
      role: "PD-AVIRP-WebUser",
      assets: ["AV_Tester_View"],
    },
    // Replatform Project
  {
    role: "PD-AVIRP-LawEnforcement",
    assets: [
      "AV_Vehicle_Search",
      "AV_Document_Incident",
      "AV_Document_Securing",
      "AV_Document_Towing",
      "AV_Document_Extrication",
      "AV_Document_Firefight",
      "AV_Responder_Help"
    ],
  },
  {
    role: "PD-AVIRP-Firefighting",
    assets: [
      "AV_Vehicle_Search",
      "AV_Document_Incident",
      "AV_Document_Securing",
      "AV_Document_Extrication",
      "AV_Document_Firefight",
      "AV_Responder_Help"
    ],
  },
  {
    role: "PD-AVIRP-EMT",
    assets: [
      "AV_Vehicle_Search",
      "AV_Document_Incident",
      "AV_Document_Securing",
      "AV_Document_Extrication",
      "AV_Document_Firefight",
      "AV_Responder_Help"
    ],
  },
  {
    role: "PD-AVIRP-Towing",
    assets: [
      "AV_Vehicle_Search",
      "AV_Document_Securing",
      "AV_Document_Towing",
      "AV_Responder_Help"
    ],
  }
  ];

  //this is where we need to plug in user ROLE from ESEC Header
  let [currentUserRole, setCurrentUserRole] =  useState<string>(esecUserRole);
  let [testerId, setTesterId] =  useState<number>(esecTesterId);//Add it from ESEC Header

  //Create the auth data to be passed as context
  let authData = useMemo(() => ({
    setCurrentUserRole: (role: string) =>{setCurrentUserRole(role)},
    setTesterId: (testerId: number) =>{setTesterId(testerId)},
    isAuthorized: (asset: string) => {     
      //check if the role has access to the asset passed in, if
      let accessPermitted = JSON.stringify(
        userAuthData.find((item) => item.role === currentUserRole)?.assets
      )?.indexOf(asset);
      //If there is no data found in the auth data collection, there is no access permission and return false
      return accessPermitted !== undefined && accessPermitted !== -1;
    },
    currentUserRole: currentUserRole,
    testerId: testerId
  }), [currentUserRole, testerId]);

  

  


  return (
    <UserAuthContext.Provider value={authData}>
      {children}
    </UserAuthContext.Provider>
  );
}
